import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { adminApi } from '../api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (adminApi.hasToken()) {
        try { const me = await adminApi.me(); setAdmin(me); }
        catch { adminApi.logout(); setAdmin(null); }
      }
      setReady(true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (creds) => { const a = await adminApi.login(creds); setAdmin(a); return a; };
  const logout = () => { adminApi.logout(); setAdmin(null); };

  const value = useMemo(() => ({ admin, login, logout, ready }), [admin, ready]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
